module.exports = __webpack_public_path__ + "img/1525638041.d61a6fb0.jpg";